import * as React from 'react';
import { LoginType } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { Chevron } from '../../../../../Icons';
import cn from 'classnames';

interface Props {
	selected?: boolean;
	type: LoginType;
	value?: string;
	onClick?: () => void;
}

const LoginTypeSelector: React.FC<Props> = ({ selected, type, value, onClick }) => {
	const { LoginTypeSelector: css } = useTheme('LoginPage');

	return (
		<div className={cn(css.item, { [css.selected]: selected })} onClick={onClick}>
			<div className={css.info}>
				<span className={css.type}>{type}</span>
				{value && <span>{value}</span>}
			</div>

			<span className={css.icon}>{Chevron}</span>
		</div>
	);
};

export default LoginTypeSelector;
